import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-failBindEmail",
  "use": "icon-failBindEmail-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-failBindEmail\"><defs><style type=\"text/css\"></style></defs><path d=\"M794.8 718.2L1014 937.4 957.4 994 738.2 774.8 519 994l-56.6-56.6 219.2-219.2L462.5 499l56.6-56.6 219.2 219.2 219.2-219.2L1014 499 794.8 718.2zM114 182h796v158.6L677 467.3v56.9l233-126.8v20.7h50V132H64v760h209.9v-50H114V397.5l257.8 140.2v-56.9L114 340.6V182z\" fill=\"\" p-id=\"4086\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/failBindEmail.svg
// module id = Ps4g
// module chunks = 48